import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const OdsFileImage = (t0)=>{
    const $ = c(9);
    const { width, height } = t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4064 5H35.5L48.9999 18.8V45.0115C48.9999 48.3218 46.1974 50.9999 42.7453 50.9999H19.2666C15.8025 50.9999 13 48.3218 13 45.0115V10.9884C12.9999 7.6781 15.9423 5 19.4064 5Z",
            fill: "#E2E6EB"
        });
        t2 = /*#__PURE__*/ jsx("path", {
            d: "M35.5289 14.384V5L48.9999 18.8L40.0192 18.8C35.9779 18.8 35.3418 15.856 35.5289 14.384Z",
            fill: "#BAC6D1"
        });
        t3 = /*#__PURE__*/ jsx("path", {
            d: "M7 33C7 30.7909 8.79086 29 11 29H38C40.2091 29 42 30.7909 42 33V43C42 45.2091 40.2091 47 38 47H11C8.79086 47 7 45.2091 7 43V33Z",
            fill: "#3F8904"
        });
        t4 = /*#__PURE__*/ jsx("path", {
            d: "M35.9385 35.9897C35.9016 35.6173 35.7431 35.328 35.463 35.1218C35.1829 34.9156 34.8028 34.8125 34.3227 34.8125C33.9965 34.8125 33.721 34.8587 33.4964 34.951C33.2717 35.0402 33.0994 35.1649 32.9793 35.3249C32.8624 35.485 32.8039 35.6665 32.8039 35.8697C32.7978 36.0389 32.8331 36.1867 32.9101 36.3129C32.9901 36.439 33.0994 36.5483 33.2379 36.6406C33.3764 36.7299 33.5364 36.8084 33.718 36.8761C33.8996 36.9407 34.0934 36.9961 34.2996 37.0423L35.1491 37.2454C35.5615 37.3377 35.94 37.4608 36.2847 37.6147C36.6294 37.7686 36.928 37.9579 37.1803 38.1825C37.4327 38.4072 37.6281 38.6719 37.7666 38.9766C37.9082 39.2812 37.9805 39.6306 37.9836 40.0245C37.9805 40.6031 37.8328 41.1048 37.5404 41.5295C37.2511 41.9511 36.8326 42.2789 36.2847 42.5128C35.74 42.7436 35.0829 42.859 34.3135 42.859C33.5502 42.859 32.8855 42.7421 32.3192 42.5082C31.756 42.2743 31.3159 41.928 30.9989 41.4695C30.6849 41.0078 30.5203 40.4369 30.5049 39.7567H32.4392C32.4607 40.0737 32.5515 40.3384 32.7116 40.5508C32.8747 40.7601 33.0917 40.9186 33.3625 41.0263C33.6364 41.1309 33.9457 41.1832 34.2904 41.1832C34.629 41.1832 34.9229 41.134 35.1722 41.0355C35.4245 40.937 35.62 40.8001 35.7585 40.6246C35.8969 40.4492 35.9662 40.2476 35.9662 40.0199C35.9662 39.8075 35.9031 39.629 35.7769 39.4844C35.6538 39.3397 35.4722 39.2166 35.2322 39.1151C34.9952 39.0135 34.7044 38.9212 34.3597 38.8381L33.3302 38.5795C32.5331 38.3857 31.9037 38.0825 31.442 37.6701C30.9804 37.2577 30.7511 36.7022 30.7542 36.0036C30.7511 35.4311 30.9035 34.931 31.2112 34.5032C31.5221 34.0754 31.9483 33.7415 32.49 33.5014C33.0317 33.2614 33.6472 33.1413 34.3366 33.1413C35.0383 33.1413 35.6507 33.2614 36.1739 33.5014C36.7002 33.7415 37.1095 34.0754 37.4019 34.5032C37.6943 34.931 37.8451 35.4265 37.8543 35.9897H35.9385Z",
            fill: "white"
        });
        t5 = /*#__PURE__*/ jsx("path", {
            d: "M24.7031 42.7251H21.3516V33.2706H24.7308C25.6818 33.2706 26.5005 33.4599 27.1868 33.8384C27.8731 34.2139 28.4009 34.754 28.7703 35.4588C29.1427 36.1636 29.3289 37.0069 29.3289 37.9886C29.3289 38.9735 29.1427 39.8198 28.7703 40.5277C28.4009 41.2356 27.8701 41.7788 27.1776 42.1573C26.4882 42.5359 25.6634 42.7251 24.7031 42.7251ZM23.3505 41.0124H24.62C25.211 41.0124 25.708 40.9078 26.1112 40.6985C26.5174 40.4862 26.8221 40.1584 27.0252 39.7152C27.2314 39.2689 27.3345 38.6934 27.3345 37.9886C27.3345 37.29 27.2314 36.7191 27.0252 36.2759C26.8221 35.8327 26.519 35.5065 26.1158 35.2972C25.7126 35.0879 25.2156 34.9833 24.6247 34.9833H23.3505V41.0124Z",
            fill: "white"
        });
        t6 = /*#__PURE__*/ jsx("path", {
            d: "M19.8708 37.9979C19.8708 39.0289 19.6754 39.906 19.2846 40.6293C18.8968 41.3525 18.3674 41.9049 17.6965 42.2866C17.0286 42.6651 16.2777 42.8544 15.4436 42.8544C14.6034 42.8544 13.8494 42.6636 13.1816 42.282C12.5137 41.9003 11.9859 41.3479 11.5981 40.6246C11.2103 39.9014 11.0164 39.0258 11.0164 37.9979C11.0164 36.9669 11.2103 36.0897 11.5981 35.3665C11.9859 34.6432 12.5137 34.0923 13.1816 33.7138C13.8494 33.3321 14.6034 33.1413 15.4436 33.1413C16.2777 33.1413 17.0286 33.3321 17.6965 33.7138C18.3674 34.0923 18.8968 34.6432 19.2846 35.3665C19.6754 36.0897 19.8708 36.9669 19.8708 37.9979ZM17.8442 37.9979C17.8442 37.33 17.7442 36.7668 17.5441 36.3082C17.3472 35.8497 17.0686 35.5019 16.7086 35.2649C16.3485 35.0279 15.9268 34.9094 15.4436 34.9094C14.9605 34.9094 14.5388 35.0279 14.1787 35.2649C13.8186 35.5019 13.5386 35.8497 13.3385 36.3082C13.1416 36.7668 13.0431 37.33 13.0431 37.9979C13.0431 38.6657 13.1416 39.2289 13.3385 39.6875C13.5386 40.1461 13.8186 40.4938 14.1787 40.7308C14.5388 40.9678 14.9605 41.0863 15.4436 41.0863C15.9268 41.0863 16.3485 40.9678 16.7086 40.7308C17.0686 40.4938 17.3472 40.1461 17.5441 39.6875C17.7442 39.2289 17.8442 38.6657 17.8442 37.9979Z",
            fill: "white"
        });
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = t6;
    } else {
        t1 = $[0];
        t2 = $[1];
        t3 = $[2];
        t4 = $[3];
        t5 = $[4];
        t6 = $[5];
    }
    let t7;
    if ($[6] !== height || $[7] !== width) {
        t7 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 56 56",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2,
                t3,
                t4,
                t5,
                t6
            ]
        });
        $[6] = height;
        $[7] = width;
        $[8] = t7;
    } else t7 = $[8];
    return t7;
};
export { OdsFileImage };
